export const accent = '#933B60';
